import { render, staticRenderFns } from "./ModuleSection.vue?vue&type=template&id=cbd46c9a&"
import script from "./ModuleSection.vue?vue&type=script&lang=js&"
export * from "./ModuleSection.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports